import React from 'react'
import { CopySimple, PauseCircle } from '@phosphor-icons/react'
import resolveIcon from '../icon/resolveIcon'

export default function FormHeaderDetailActions({
  onSecondary,
  onPrimary,
  secondaryLabel = 'Suspender tarea',
  primaryLabel = 'Crear copia de tarea',
  secondaryIcon: SecondaryIcon = PauseCircle,
  primaryIcon: PrimaryIcon = CopySimple,
  secondaryIconNode = null,
  primaryIconNode = null,
  secondaryVariant = 'danger',
  iconSize = 16,
  iconWeight = 'regular',
  showSecondary = true,
  showSecondaryIcon = true,
  showPrimaryIcon = true,
  disabled = false,
  secondaryDisabled = false,
  primaryDisabled = false,
  className = '',
  primaryButtonClassName = '',
  secondaryButtonClassName = '',
  stackOnMobile = false
}) {
  const rootClass = [
    'form-header-actions',
    stackOnMobile ? 'form-header-actions--stack-mobile' : '',
    className
  ]
    .filter(Boolean)
    .join(' ')

  const resolvedSecondaryIcon = resolveIcon({
    icon: SecondaryIcon,
    iconNode: secondaryIconNode,
    size: iconSize,
    weight: iconWeight
  })

  const resolvedPrimaryIcon = resolveIcon({
    icon: PrimaryIcon,
    iconNode: primaryIconNode,
    size: iconSize,
    weight: iconWeight
  })

  return (
    <div className={rootClass}>
      {showSecondary && (
        <button
          type="button"
          className={[
            'form-header-action-btn',
            `form-header-action-btn--${secondaryVariant}`,
            secondaryButtonClassName
          ]
            .filter(Boolean)
            .join(' ')}
          onClick={onSecondary}
          disabled={disabled || secondaryDisabled}
        >
          {showSecondaryIcon && resolvedSecondaryIcon && (
            <span className="form-header-action-btn__icon" aria-hidden="true">
              {resolvedSecondaryIcon}
            </span>
          )}
          {secondaryLabel}
        </button>
      )}

      <button
        type="button"
        className={['form-header-action-btn', 'form-header-action-btn--primary', primaryButtonClassName]
          .filter(Boolean)
          .join(' ')}
        onClick={onPrimary}
        disabled={disabled || primaryDisabled}
      >
        {showPrimaryIcon && resolvedPrimaryIcon && (
          <span className="form-header-action-btn__icon" aria-hidden="true">
            {resolvedPrimaryIcon}
          </span>
        )}
        {primaryLabel}
      </button>
    </div>
  )
}
